import React, { useEffect } from "react";
import Newnavigation from "../../components/new-navigation/new_navigation";
import PageBanner from "../../components/page-banner/page-banner";
import ContactNew from "../../components/contact-form/ContactNew";
import Footer from "../../components/footer/Footer";
import { TRAVEL_BG, BG7 } from "../../assets/images/index";
import { TravelandHospitalityWhatwedo, TravelandHospitalityOurMissons, KeyserviceTravelandHospitality, TravelandHospitalityAccord } from "../../utils/Travel&Hospitality";
import PageSmallBanner from "../../components/page-small-banner/page-small-banner";
import KeyServices from "../../components/key-services/KeyServices";
import OurMissions from "../../components/Our-missions/OurMissions";
import ComAccord from "../../components/Accordian/ComAccord";
import WhatweDo from "../../components/what-we-do-img/whatweDo";
import { motion } from "framer-motion";
import { TravelSeo } from "../../utils/Seo";
import HeaderSeo from "../../components/HeaderSeo/Headerseo";

const TravelandHospitality = () => {
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
    >
    <div>
      <HeaderSeo data={TravelSeo}/>
      <Newnavigation routeName="Travel" />
      <PageBanner
        bg={TRAVEL_BG}
        title="Grow Your Travel & Hospitality Business with Techno Genesis"
        contact="Contact Us"
      />
      <WhatweDo data={TravelandHospitalityWhatwedo} />
      <OurMissions data={TravelandHospitalityOurMissons} />
      <KeyServices data={KeyserviceTravelandHospitality} heading={"Travel & Hospitality Solutions"} />
      <div className="mt-100 mb-50">
        <PageSmallBanner
          isBtn={true}
          btn_text="Contact Us"
          title="Ready to elevate your Travel and Hospitality business? Explore our tailored solutions, seamlessly blending innovation and efficiency to deliver exceptional experiences. Contact us today for a consultation!"
          bg={BG7}
          height="357px"
        />
      </div>
      <div className="mb-50">
        <ComAccord data={TravelandHospitalityAccord} />
      </div>
      <ContactNew />
      <Footer />
    </div>
    </motion.div>
  );
};

export default TravelandHospitality;
